<template>
  <q-card flat>
    <q-card-section class="row items-center q-pb-none">
      <div>
        <div class="text-bold">{{ CustomerInfo.Cs_Name }}
          <q-badge v-if="CustomerInfo.State_Name && CustomerInfo.State_Name!==''" align="top"
                   :label="CustomerInfo.State_Name" color="brown-5"/>
          <q-badge v-if="CustomerInfo.City_Name && CustomerInfo.City_Name!==''" align="top"
                   :label="CustomerInfo.City_Name" color="brown-5" class="q-ml-xs"/>
        </div>
        <div class="row q-ml-xs">
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ CustomerInfo.Cs_Code }}</b><i>)</i>
          </q-badge>
          <q-badge v-if="remCredit > 0" color='red-14' class="q-ml-xs"><i>بدهکاری(</i><b
              dir="ltr">{{ Math.abs(remCredit) | toCurrency }}</b><i>) ریال</i>
          </q-badge>
          <q-badge v-if="remCredit < 0" color='teal' class="q-ml-xs"><i>بستانکاری(</i><b
              dir="ltr">({{ Math.abs(remCredit) | toCurrency }})</b><i>) ریال</i>
          </q-badge>
        </div>
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>
    <q-card-section>
      <q-card-actions>
        <q-btn color="indigo" text-color="white" icon="payment" label="مشاهده چک ها" @click="payBookDialog=true"/>
        <q-btn color="indigo"
               v-if="$store.state.roles.some(v=>['admin','can_print_customer_finance_document'].includes(v))"
               text-color="white" icon="print" label="چاپ" @click="loadReport"/>
      </q-card-actions>
      <q-card-section class="no-padding">
        <q-table
            table-style="max-height: 500px"
            :data="items"
            row-key="index"
            wrap-cells
            bordered
            :rows-per-page-options="[0]"
            :filter="filter">
          <template v-slot:header>
            <q-tr class="bg-blue-grey text-white fixed-header-position">
              <q-td class="text-subtitle1">
                شرح
              </q-td>
              <q-td class="text-subtitle2">
                نوع حساب
              </q-td>
              <q-td class="text-subtitle2">
                تاریخ سند
              </q-td>
              <q-td class="text-subtitle2">
                بدهکاری
              </q-td>
              <q-td class="text-subtitle2">
                بستانکاری
              </q-td>
              <q-td class="text-subtitle2">
                مانده
              </q-td>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-subtitle2">
                <q-card flat>
                  <q-card-section class="no-padding">
                    <q-btn
                        v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0"
                        round flat icon="timeline" color="indigo"
                        @click="showOrderTimeLine(removeSpecialCharacter(props.row.ArticleDesc.split('#')[2]), props.row.ArticleDesc.indexOf('برگشت'), props.row.ArticleDesc.indexOf('خرید')>0)">
                      <q-tooltip>
                        رهگیری سفارش
                      </q-tooltip>
                    </q-btn>
                    <q-btn flat size="md" round class="q-mt-xs"
                           color="indigo"
                           icon="print"
                           v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0 &&
                            !props.row.ArticleDesc.includes('خرید')"
                           @click="printFactor(props.row)"/>
                    <q-btn icon="attach_file" color="blue-grey" flat round
                           clickable
                           @click="downloadAttachment(props.row)"
                           v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0 &&
                            props.row.ArticleDesc.includes('خرید')">
                      <q-tooltip>
                        دانلود ضمیمه
                      </q-tooltip>
                    </q-btn>
                    <q-btn flat size="md" round class="q-mt-xs"
                           color="red"
                           icon="delete"
                           @click="deleteItems(props.row)"
                           v-if="props.row.ArticleDesc && (props.row.ArticleDesc.indexOf('#') > 0 || props.row.ArticleDesc.includes('سند هزینه حمل بار')) && $store.state.roles.some(v=>['admin','can_delete_finance_document'].includes(v))">
                      <q-tooltip>
                        حذف سند مالی
                      </q-tooltip>
                    </q-btn>
                    <q-btn
                        v-if="props.row.ArticleDesc && props.row.Sale_PayReceive<props.row.Credit && props.row.ArticleDesc.indexOf('#') > 0 && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                        flat
                        round
                        color="green"
                        icon="attach_money">
                      <q-tooltip>
                        ثبت رسید پرداخت
                      </q-tooltip>
                      <InvoiceSettlement
                          :sale-num="parseInt(removeSpecialCharacter(props.row.ArticleDesc.split('#')[2]))"/>
                    </q-btn>
                    <q-badge color="red" text-color="white" :label="props.row.VoucherNum"/>
                    {{ removeSpecialCharacter(props.row.ArticleDesc) }}
                    <q-chip icon="shopping_basket" square
                            :clickable="props.row.ArticleDesc && !props.row.ArticleDesc.includes('خرید')"
                            :color="props.row.Sale_PayReceive>=props.row.Credit?'green':'red'"
                            text-color="white"
                            v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0"
                            @click="showFactorItems(removeSpecialCharacter(props.row.ArticleDesc.split('#')[2]), props.row.ArticleDesc.indexOf('برگشت'))">
                      {{ removeSpecialCharacter(props.row.ArticleDesc.split('#')[2]) }}
                      <q-tooltip>
                        {{ props.row.Sale_PayReceive >= props.row.Credit ? 'تسویه شده' : 'تسویه نشده' }}
                        <q-space v-if="props.row.Sale_PayReceive"/>
                        <span v-if="props.row.Sale_PayReceive">
                          <span>مبلغ پرداختی:</span>
                          <span>  {{ props.row.Sale_PayReceive.toLocaleString() }}</span>
                        </span>
                      </q-tooltip>
                    </q-chip>
                    <q-icon name="arrow_back"
                            v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0 && props.row.BaseSale_Num_x && !props.row.ArticleDesc.includes('خرید')"/>
                    <q-chip icon="shopping_basket" square
                            clickable
                            :label="props.row.BaseSale_Num_x"
                            @click="showFactorItemsFromBaseSaleNum(props.row.BaseSale_Num_x, 1)"
                            v-if="props.row.ArticleDesc && props.row.ArticleDesc.indexOf('#') > 0 && props.row.BaseSale_Num_x && !props.row.ArticleDesc.includes('خرید')"/>
                  </q-card-section>
                </q-card>
              </q-td>
              <q-td>
                <q-chip square color="teal" text-color="white"
                        v-if="props.row.AccName && true && props.row.AccName!==' '
                        && props.row.AccName!==''"
                        :label="props.row.AccName"/>
              </q-td>
              <q-td>
                <q-chip v-if="props.row.VoucherDate!==0" color="red" text-color="white" icon="calendar_today" square
                        :label="formatDateString(props.row.VoucherDate)"/>
              </q-td>
              <q-td>
                <q-badge v-if="props.row.VoucherDate!==0" color="pink-14" text-color="white"
                         :label="props.row.Credit.toLocaleString()"/>

              </q-td>
              <q-td>
                <q-badge v-if="props.row.VoucherDate!==0" color="green" text-color="white"
                         :label="props.row.Debit.toLocaleString()"/>
              </q-td>
              <q-td>
                <q-badge v-if="props.row.VoucherDate!==0" color="red-14" text-color="white"
                         :label="props.row.cum_sum >0 ?props.row.cum_sum.toLocaleString():`(${Math.abs(props.row.cum_sum).toLocaleString()})`"/>
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
      <q-card-actions>
        <q-btn color="indigo" icon="payment" text-color="white" label="مشاهده چک ها" @click="payBookDialog=true"/>
      </q-card-actions>
    </q-card-section>
    <q-dialog :maximized="$q.screen.lt.md" v-model="payBookDialog">
      <CustomerPayBook :customer-info="CustomerInfo" :rem-credit="remCredit"/>
    </q-dialog>

    <q-dialog maximized v-model="factorDialog">
      <FactorDetails :sale-state="saleState" :factor-items="factorItems" :sale-kind="saleState"
                     :sale-num="selectedSale_Num"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :remain-ordered="undefined" :sale-num="selectedSaleNum" :sale-date="selectedSaleDate"
                     :buy="selectedBuyFactor"/>
    </q-dialog>
    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog title="چاپ فاکتور" :factor-info="selectedItem" :customer-code="selectedCustomerCode" />
    </q-dialog>
  </q-card>
</template>

<script>
import CustomerPayBook from "@/components/customers/CustomerPayBook";
import FactorDetails from "@/components/Factor/FactorDetails";
import {mapActions} from "vuex";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import InvoiceSettlement from "@/components/Factor/InvoiceSettlement";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";

export default {
  name: "CustomerFinanceDesktop",
  components: {FactorPrintDialog, InvoiceSettlement, OrderTimeLine, FactorDetails, CustomerPayBook},
  props: {
    items: {
      type: Array,
      required: true,
      default: ()=> []
    },
    CustomerInfo: {
      type: Object,
      required: true
    },
    remCredit: {
      required: true
    },
    filter:{
      type: String,
      default:()=> '',
      required: true
    }
  },
  data() {
    return {
      selectedCustomerCode: undefined,
      selectedItem:undefined,
      factorPrintDialog:false,
      selectedBuyFactor: false,
      showTimeLineDialog: false,
      selectedSaleNum: '',
      selectedSaleDate: '',
      saleState: '',
      selectedSale_Num: '',
      factorItems: [],
      factorDialog: false,
      payBookDialog: false,
      pagination: {
        rowsPerPage: 100
      },
    }
  },
  methods: {
    ...mapActions({
      getFactorItems: 'Orders/getFactorItems',
      deleteDocument: 'Orders/deleteFinanceDocument',
      getFactorInfo: 'Products/getFactorInfo',
      downloadFile: 'Buys/downloadFile',
    }),
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `BuyOrders/${args.Sale_Num}_${args.Sale_Kind}.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با مشتریان/گزارش معین مشتری?rs:Format=PDF&Code=${this.CustomerInfo.Cs_Code}&CustomerInfo=${`${this.CustomerInfo.Cs_FirName} ${this.CustomerInfo.Cs_FamName}`}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showOrderTimeLine(saleNum, saleKind, buy) {
      if (!buy) {
        const payload = {Sale_Num: saleNum, Sale_Kind: saleKind > -1 ? -1 : 1}
        this.getFactorInfo(payload).then((res) => {
          if (res.length > 0) {
            if (res[0].Order_Num) {
              this.selectedSaleNum = res[0].Order_Num
              this.selectedSaleDate = res[0].Sale_Date
              this.selectedBuyFactor = false;
              this.showTimeLineDialog = true
            }
          }
        })
      } else {
        this.selectedSaleNum = parseInt(saleNum)
        this.selectedSaleDate = ''
        this.selectedBuyFactor = buy;
        this.showTimeLineDialog = true
      }
    },
    deleteItems(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'سند مالی حذف گردد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteDocument({
          documentNum: row.VoucherNum,
          accYear: row.VoucherDate.toString().substr(0, 4),
          Sale_Num: this.removeSpecialCharacter(row.ArticleDesc.split('#')[2]),
          SaleKind: row.ArticleDesc.indexOf('برگشت') > -1 ? -1 : 1
        }).then(() => {
          this.items = this.items.filter(item => item.VoucherNum !== row.VoucherNum)
        })
      })
    },
    showFactorItems(sale_num, saleKind) {
      this.saleState = saleKind > 0 ? -1 : 1;
      this.getFactorItems({
        sale_num: sale_num,
        sale_kind: this.saleState
      }).then((res) => {
        this.factorItems = res
        this.selectedSale_Num = parseInt(sale_num)
        this.factorDialog = true
      })
    },
    showFactorItemsFromBaseSaleNum(sale_num, saleKind) {
      this.saleState = 1
      this.getFactorItems({
        sale_num: sale_num,
        sale_kind: saleKind
      }).then((res) => {
        this.factorItems = res
        this.selectedSale_Num = parseInt(sale_num)
        this.factorDialog = true
      })
    },
    removeSpecialCharacter(str) {
      if (str) {
        return str.replace(/[#<>]/gi, ' ');
      } else {
        return ''
      }
    },
    formatDateString(str) {
      let moment = require('jalali-moment');
      let MomentDate = moment(str, 'jYYYYjMMjDD');
      return MomentDate.locale('fa').format('yyyy/MM/DD');
    },
    async printFactor(rowInfo) {
      this.selectedItem = rowInfo
      this.selectedCustomerCode = rowInfo.Cs_Code
      this.factorPrintDialog = true
    },
  }
}
</script>


<style scoped>
.fixed-header-position {
  position: sticky;
  top: 0;
  background: cadetblue;
  z-index: 1000
}
</style>